module.exports = __webpack_public_path__ + "img/6.71b389d8.jpeg";